SidebarState = require 'view-models/sidebar-state'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class HeaderBoardsButtonView extends View

  className: 'header-boards-button'

  events:
    'click .js-boards-menu': 'toggleBoardsSidebar'

  render: ->

    @$el.html(
      templates.fill(
        'header_boards_menu_button'
      )
    )

    @

  toggleBoardsSidebar: (e) ->
    Util.stop(e)
    track("Header", "Boards Menu", "Toggle Boards Menu")

    if SidebarState.getShowSidebar()
      SidebarState.hideSidebar()
    else
      SidebarState.showSidebar()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-boards-button-view.coffee